import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import Label from '../../../label';
import {directoryLabelsToCollapse} from '../../../../../../../../../actions/directoryGroupActions';
import './index.css';

/**
 * @return {JSX | null}
 */

function DirectoryGroupBody () {

	const directoryGroups = useSelector(state => state.directoryGroupReducer.findDirectoryGroups);
	const profile = useSelector(state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

	useEffect( () => {
		if(directoryGroups && directoryGroups.directoryContactGroupsV4[0].rootOu.childOu.length > 3){
			directoryGroups.directoryContactGroupsV4[0].rootOu.childOu.forEach( childOuItem => {
				if(childOuItem.childOu.length > 0){
					dispatch(directoryLabelsToCollapse({labelId: childOuItem.id, labelType: childOuItem.type}))
				}
			});
		}
	}, [dispatch, directoryGroups]);

	let syncState = directoryGroups ? directoryGroups.state : null;
	let position = 0;


	return (
		<div className={`directory-group-body border-bottom${!directoryGroups ? ' directory-group-pending' : ''}`}>
			{
				directoryGroups && directoryGroups.directoryContactGroupsV4.length > 0
				?
					directoryGroups.directoryContactGroupsV4.map( (directoryContactGroup) => {
						return (
							<React.Fragment key={directoryContactGroup.rootOu.id}>
								<Label
									id={directoryContactGroup.rootOu.id}
									name={directoryContactGroup.rootOu.name}
									status={directoryContactGroup.rootOu.status}
									nbOfContact={directoryContactGroup.rootOu.nbOfContact}
									permission={directoryContactGroup.rootOu.permission}
									sharingPreview={directoryContactGroup.rootOu.sharingPreview}
									sharingNumber={directoryContactGroup.rootOu.sharingNumber}
									type={"directory"}
									activeDirectory={directoryContactGroup.activeDirectory}
									ownerId={directoryContactGroup.rootOu.ownerId}
									ownerName={directoryContactGroup.rootOu.ownerName}
									index={position}
									directorySyncType={directoryContactGroup.directorySyncType}
									directorySyncStatus={directoryContactGroup.directorySyncStatus}
									directoryDisplayStatus={directoryContactGroup.directoryDisplayStatus}
									syncState={syncState}
									customerId={directoryContactGroup.customerId}
									noCaret={
										(
											directoryContactGroup.rootOu.childOu.length === 0
											&& (profile.accessStatus.isOrgUnitGranted === true)
										)
										|| (
											directoryContactGroup.rootOu.childOu.length === 0
											&& (profile.accessStatus.isOrgUnitGranted === false && profile.isAdmin === false)
										)
									}
								/>
								{
									directoryContactGroup.rootOu.childOu.map( childOuLv1 => {
										return (
											<React.Fragment key={childOuLv1.id}>
												<Label
													key={childOuLv1.id}
													id={childOuLv1.id}
													name={childOuLv1.name}
													status={childOuLv1.status}
													nbOfContact={childOuLv1.nbOfContact}
													permission={childOuLv1.permission}
													sharingPreview={childOuLv1.sharingPreview}
													sharingNumber={childOuLv1.sharingNumber}
													type={"childDirectory"}
													activeDirectory={directoryContactGroup.activeDirectory}
													ownerId={childOuLv1.ownerId}
													ownerName={childOuLv1.ownerName}
													index={position}
													syncState={syncState}
													customerId={directoryContactGroup.customerId}
													noCaret={
														childOuLv1.childOu.length === 0
														|| (profile.accessStatus.isOrgUnitGranted === false && profile.isAdmin === false && profile.customerId === directoryContactGroup.customerId)
													}
												/>
												{
													childOuLv1.childOu.map( childOuLv2 => {
														return (
															<Label
																key={childOuLv2.id}
																id={childOuLv2.id}
																name={childOuLv2.name}
																status={childOuLv2.status}
																nbOfContact={childOuLv2.nbOfContact}
																permission={childOuLv2.permission}
																sharingPreview={childOuLv2.sharingPreview}
																sharingNumber={childOuLv2.sharingNumber}
																type={"childDirectoryLv2"}
																activeDirectory={directoryContactGroup.activeDirectory}
																ownerId={childOuLv2.ownerId}
																ownerName={childOuLv2.ownerName}
																index={position}
																syncState={syncState}
																customerId={directoryContactGroup.customerId}
																noCaret={true}
															/>
														)
													})
												}
											</React.Fragment>
										)
									})
								}
							</React.Fragment>
						)
					})
				:
					Array(1).fill("").map( (value, index) => (
						<div key={index} style={
							index !== Array(1).fill("").length - 1
								? { display: 'flex', alignItems: 'center', gap: '1.2em', lineHeight: 1, marginBottom: '.5em'}
								: { display: 'flex', alignItems: 'center', gap: '1.2em', lineHeight: 1}
						}>
							<Skeleton width={30} height={30} />
							<div style={{ flexGrow: 1 }}>
								<Skeleton height={30} />
							</div>
						</div>
					))
			}
		</div>
	)

}

export default DirectoryGroupBody;
